import { IAppointmentDetails }
  from "../../services/appointment-list/appointment-list.interface";
import { IAppointmentCreateResponse } from "../../services/create-appointment-v2/create-appointment-v2.interface";
import { actionTypes } from "./bookedAppointments.actions";

export interface IBookedAppointmentsState {
  appointmentsResponse: IAppointmentCreateResponse | null;
  appointmentsRescheduleResponse: IAppointmentCreateResponse | null;
  selectedVisit: IAppointmentDetails | null;
  appointmentDetails: IAppointmentDetails | null;
  pastAppointments: IAppointmentDetails[] | [];
  groupedAppointments: IAppointmentDetails[] | null;
}

const initialState: IBookedAppointmentsState = {
  appointmentsResponse: null,
  appointmentsRescheduleResponse: null,
  selectedVisit: null,
  appointmentDetails: null,
  pastAppointments: [],
  groupedAppointments: null,
};

export const bookedAppointmentsReducer = (
  state: IBookedAppointmentsState = initialState,
  action: { type: string, payload: any },
) => {
  switch (action.type) {
  case actionTypes.SET_ADD_APPOINTMENT_RESPONSE:
    return {
      ...state,
      appointmentsResponse: action.payload,
    };
  case actionTypes.SET_RESCHEDULE_APPOINTMENT_RESPONSE:
    return {
      ...state,
      appointmentsRescheduleResponse: action.payload,
    };
  case actionTypes.SET_VISIT_SELECTED:
    return {
      ...state,
      selectedVisit: action.payload,
    };
  case actionTypes.SET_APPOINTMENT_DETAILS:
    return {
      ...state,
      appointmentDetails: action.payload,
    };
  case actionTypes.SET_PAST_APPOINTMENTS:
    return {
      ...state,
      pastAppointments: action.payload,
    };
  case actionTypes.SET_GROUPED_APPOINTMENTS:
    return {
      ...state,
      groupedAppointments: action.payload,
    };
  default:
    return state;
  }
};
